import { motion } from "framer-motion";

const jobs = [
  {
    src: "/work-1.jpg",
    tag: "Residential Install",
    title: "Goodman Condenser",
    tall: true,
  },
  {
    src: "/work-2.jpg",
    tag: "Commercial",
    title: "Ruud Rooftop Package Unit",
  },
  {
    src: "/work-3.jpg",
    tag: "Ductless",
    title: "Mini-Split Wall Mount",
  },
];

export default function Gallery() {
  return (
    <section
      id="work"
      className="relative py-24 md:py-32 border-b border-white/10"
      data-testid="work-gallery-section"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-16 md:mb-20">
          <div>
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 0.7 }}
              className="font-mono-tech text-xs uppercase tracking-[0.3em] text-[#FF6B00] mb-6"
            >
              Fresh Off The Truck
            </motion.p>
            <motion.h2
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 0.8, delay: 0.1 }}
              className="font-display font-bold uppercase tracking-tighter text-4xl md:text-5xl lg:text-6xl leading-tight"
            >
              Recent work,
              <br />
              <span className="text-[#FF6B00]">real jobs.</span>
            </motion.h2>
          </div>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.7, delay: 0.2 }}
            className="max-w-sm text-zinc-400 text-base"
          >
            No stock photos here — these are actual installs by our crew across
            East Tennessee, from back porches to commercial rooftops.
          </motion.p>
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          {jobs.map((job, i) => (
            <motion.figure
              key={job.src}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.8, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] }}
              className={`group relative overflow-hidden rounded-sm border border-white/10 hover:border-[#FF6B00]/60 transition-colors duration-500 ${
                job.tall ? "md:row-span-2 h-[480px] md:h-auto" : "h-[300px] md:h-[340px]"
              }`}
              data-testid={`work-card-${i + 1}`}
            >
              <img
                src={job.src}
                alt={job.title}
                className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-700 ease-out"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#050505]/90 via-transparent to-transparent" />
              <figcaption className="absolute bottom-0 left-0 right-0 p-6 md:p-8">
                <p className="font-mono-tech text-[10px] uppercase tracking-[0.25em] text-[#FF6B00] mb-2">
                  {job.tag}
                </p>
                <p className="font-display font-semibold uppercase tracking-tight text-xl md:text-2xl text-white">
                  {job.title}
                </p>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
